/* eslint-disable */
export default {
  _cartoon_appear_sound: 'cartoon_appear_sound',
  _cartoon_double_pop_fast: 'cartoon_double_pop fast',
  _cartoon_pop: 'cartoon_pop',
  _cartoon_slide_ascend: 'cartoon_slide_ascend',
  _cartoon_slide_flip: 'cartoon_slide_flip',
  _cartoon_tiptoe_1: 'cartoon_tiptoe_1',
  _cartoon_tiptoe_2: 'cartoon_tiptoe_2',
  _click: 'click',
  _extra_points: 'extra_points',
  _gameOver: 'gameOver',
  _math_lines_music: 'math_lines_music',
  _powerup: 'powerup',
  _score_tally_loop: 'score_tally_loop',
  _swish: 'swish',
  _win_level: 'win_level',
}